module.exports = __webpack_public_path__ + "static/img/16.93e9ade0.jpeg";